import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('research_char_bot_react');

if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
